import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SiteHeader } from '@/components/Organisms/SiteHeader';
import { SiteFooter } from '@/components/Organisms/SiteFooter';
import { StickyCta } from '@/components/Organisms/StickyCta';
export function PageShell({ children }) {
    return (_jsxs("div", { className: "flex min-h-screen w-full flex-col bg-surface text-ink", children: [_jsx(SiteHeader, {}), _jsx("main", { className: "flex-1 pb-24 md:pb-0", children: children }), _jsx(SiteFooter, {}), _jsx(StickyCta, {})] }));
}
